
export const translations = {
  es: {
    hello: "Hola",
    savedChats: "Mis Chats",
    conversationHistory: "Tu historial de conversaciones",
    noSavedChats: "No hay chats guardados aún.",
    question: "Pregunta:",
    answer: "Respuesta:",
    saveChanges: "Guardar",
    error: "Error",
    failed_load_chats: "Error al cargar los chats guardados",
    listening: "Escuchando...",
    failed_send_message: "Error al enviar el mensaje",
    no_messages_save: "No hay mensajes para guardar",
    success: "Éxito",
    chat_saved: "Chat guardado exitosamente",
    failed_save_chat: "Error al guardar el chat",
    title: "Chat de Inmigración",
    placeholder: "Escribe tu pregunta aquí...",
    saving: "Guardando...",
    save_chat: "Guardar Chat",
    mobile_disclaimer: "Versión móvil",
    desktop_disclaimer: "Versión de escritorio"
  },
  en: {
    hello: "Hello",
    savedChats: "Saved Chats", 
    conversationHistory: "Your conversation history",
    noSavedChats: "No saved chats yet.",
    question: "Question:",
    answer: "Answer:",
    saveChanges: "Save Changes",
    error: "Error",
    failed_load_chats: "Failed to load saved chats",
    listening: "Listening...",
    failed_send_message: "Failed to send message",
    no_messages_save: "No messages to save",
    success: "Success",
    chat_saved: "Chat saved successfully",
    failed_save_chat: "Failed to save chat",
    title: "Immigration Chat",
    placeholder: "Type your question here...",
    saving: "Saving...",
    save_chat: "Save Chat",
    mobile_disclaimer: "Mobile version",
    desktop_disclaimer: "Desktop version"
  }
};

export type Language = 'en' | 'es';
export type TranslationKey = keyof typeof translations.en;

export const getTranslations = (language: Language) => {
  return translations[language];
};
